import { BaseGetInputModel } from "src/models/http/InputModel/BaseGetInputModel"

export type TieupSearchGetParams = {
  query: string[]
  genres: string[]
  order?: string
  offset?: number
  limit?: number
  isR15?: "yes" | "no"
  isR18?: "yes" | "no"
}
export class TieupSearchGetInputModel extends BaseGetInputModel {
  constructor(private params: TieupSearchGetParams) {
    super()
  }

  get query(): URLSearchParams {
    const searchParams = new URLSearchParams()

    if (this.params.query.length > 0) {
      searchParams.append("q", this.params.query.join(" "))
    }

    if (this.params.genres.length > 0) {
      searchParams.append("g", this.params.genres.join(","))
    }

    if (
      this.params.order &&
      (this.params.order === "date" || this.params.order === "dateasc")
    ) {
      searchParams.append("o", this.params.order)
    }

    if (this.params.offset !== undefined) {
      searchParams.append("offset", this.params.offset.toString())
    }

    if (this.params.limit !== undefined) {
      searchParams.append("limit", this.params.limit.toString())
    }

    if (this.params.isR15 !== undefined) {
      searchParams.append("is_r15", this.params.isR15)
    }

    if (this.params.isR18 !== undefined) {
      searchParams.append("is_r18", this.params.isR18)
    }

    return new URLSearchParams(searchParams)
  }
}
